var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "yellow-button",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.$emit("submit-add-item")
          },
        },
      },
      [
        _c("span", { staticClass: "yellow-button-text" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.text) + "\n\t\t"),
        ]),
        _vm._v(" "),
        _vm.showIcon
          ? _c(
              "icon-base",
              {
                attrs: {
                  width: "18",
                  height: "23",
                  iconName: "Add to My Order",
                },
              },
              [_c("icon-bag")],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }